export const getGoogleMeetUrlWithAuthUser = ({
  authUser,
  url,
}: {
  authUser: string | null | undefined;
  url: string | null | undefined;
}) => {
  if (!url || !authUser) return url ?? undefined;

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.hostname !== "meet.google.com") return url;
    if (parsedUrl.searchParams.has("authuser")) return url;

    parsedUrl.searchParams.set("authuser", authUser);
    return parsedUrl.toString();
  } catch {
    return url;
  }
};
